import { useWorkstation } from '../../appState';

import { TrainingModeFob } from './TrainingModeFob';

export function TrainingModeSignOn() {
  const workstation = useWorkstation();
  if (workstation?.hasFobReader) return <TrainingModeFob />;
  return <div>NOT FOUND</div>;
}
